import React from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';

interface RevokeInviteConfirmDialogProps {
  open: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const RevokeInviteConfirmDialog: React.FC<
  RevokeInviteConfirmDialogProps
> = ({ open, email, onConfirm, onCancel, isLoading }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel();
        }
      }}
    >
      <DialogContent aria-labelledby="revoke-invite-dialog-title">
        <DialogHeader id="revoke-invite-dialog-title">
          Revoke Invitation
        </DialogHeader>
        <DialogBody>
          Are you sure you want to revoke the invitation for{' '}
          <strong>{email}</strong>? This action cannot be undone and the
          invitation link will no longer work.
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            data-testid="confirm-revoke-button"
          >
            {isLoading ? 'Revoking...' : 'Revoke'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
